import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { approveTransaction } from "services";
import { CustomButton } from "ui";

export const ApproveTransactionButton = observer(({ hash }: { hash: string }) => {
  const { actionModals, bidTransactions } = useStores();

  const approveTxHandler = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          buttonText="Одобрить"
          text="Вы действительно хотите одобрить транзакцию?"
          successText="Транзакция одобрена"
          calledQuery={() => approveTransaction({ hash })}
          onSuccess={() =>
            setTimeout(() => {
              bidTransactions.fetch();
            }, 1500)
          }
        />
      ),
      {
        ...confirmationModalConfigs,
        title: "Одобрение транзакции",
        onClose: () => actionModals.closeAll(),
      }
    );
  };

  return (
    <CustomButton type="default" size="small" onClick={approveTxHandler}>
      Одобрить риски
    </CustomButton>
  );
});
